import { render, staticRenderFns } from "./ac-timeline-item.vue?vue&type=template&id=2a5c4542&"
import script from "./ac-timeline-item.vue?vue&type=script&lang=js&"
export * from "./ac-timeline-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports